const pricesWithDiscount = {
  off15: '$12.70',
  off25: '$11.21',
  off30: '$10.46',
  off50: '$7.45',
  free: 'free',
  twoItemsOff25: '$18.75',
  twoItemsOff70: '$7.50',
}


export default pricesWithDiscount
